
const UseTermsBenner = () => (
  <>
    <h3>Termos e condições gerais de uso do sistema Benner Metrics</h3>

    <p>
      Os serviços do software
      {' '}
      <b>Benner Metrics</b>
      {' '}
      são fornecidos pela
      {' '}
      <b>Juristec</b>
      {' '}
      Sistemas Jurídicos Integrados Ltda ("
      <b>Juristec</b>
      "), pessoa
      jurídica de direito privado, com nome fantasia, inscrita no CNPJ/MF sob o
      nº 27.434.472/0001-09, titular da propriedade intelectual sobre software, website,
      aplicativos, conteúdos e demais ativos relacionados à plataforma
      {' '}
      <b>Benner Metrics</b>
      .
    </p>

    <h3 className="section">1. Do Objeto</h3>
    <p>
      A plataforma visa licenciar o uso de seu software, website, aplicativos e demais ativos de
      propriedade intelectual, fornecendo ferramentas para auxiliar e dinamizar o dia a dia dos
      seus usuários.
    </p>
    <p>
      A plataforma caracteriza-se pela prestação dos serviços de “business intelligence” jurídico,
      que pode ser qualificado como um sistema de processamento de bases de dados na forma de
      relatórios e transformação dos mesmos em modelos gráficos por meio da aplicação de
      templates, cópia de dashboards ou criação de novos indicadores.
    </p>
    <p>
      A plataforma é comercializada através do site de sua provedora
      {' '}
      <a
        href="https://juristecplus.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://juristecplus.com.br
      </a>
      {' '}
      e acessada através do site da URL
      {' '}
      <a
        href="https://bennermetrics.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://bennermetrics.com.br
      </a>
      .
    </p>

    <h3 className="section">2. Da Aceitação</h3>
    <p>
      O presente Termo estabelece obrigações contratadas de livre e espontânea vontade, por tempo
      indeterminado, entre a plataforma e as pessoas físicas ou jurídicas, usuárias do software
      {' '}
      <b>Benner Metrics</b>
      .
    </p>
    <p>
      Ao utilizar a plataforma
      {' '}
      <b>Benner Metrics</b>
      , o usuário aceita integralmente as presentes normas e compromete-se a observá-las.
    </p>
    <p>
      A aceitação do presente instrumento é imprescindível para o acesso e para a utilização de
      quaisquer serviços fornecidos pela empresa. Caso não concorde com as disposições deste
      instrumento, o usuário não deve utilizá-los.
    </p>

    <h3 className="section">3. Do Acesso Dos Usuários</h3>
    <p>
      Serão utilizadas todas as soluções técnicas à disposição do responsável pela plataforma
      para permitir o acesso ao serviço 24 (vinte e quatro) horas por dia, 7 (sete) dias por
      semana. No entanto, a navegação na plataforma ou em alguma de suas páginas poderá ser
      interrompida, limitada ou suspensa para atualizações, modificações, ações necessárias ao
      seu bom funcionamento e/ou por força de terceiros.
    </p>

    <h3 className="section">4. Do Cadastro</h3>
    <p>
      O acesso às funcionalidades da plataforma exigirá a realização de um cadastro prévio e, a
      depender dos serviços ou produtos escolhidos, o pagamento de determinado valor.
    </p>
    <p>
      Ao se cadastrar, o usuário deverá informar dados completos, recentes e válidos, sendo de sua
      exclusiva responsabilidade manter referidos dados atualizados, bem como o usuário se
      compromete com a veracidade dos dados fornecidos.
    </p>
    <p>
      O usuário se compromete a não informar seus dados cadastrais e/ou de acesso à plataforma a
      terceiros, responsabilizando-se integralmente pelo uso que deles seja feito.
    </p>
    <p>
      Menores de 18 anos e aqueles que não possuírem plena capacidade civil deverão obter
      previamente o consentimento expresso de seus responsáveis legais para utilização da
      plataforma e dos serviços ou produtos, sendo de responsabilidade exclusiva dos mesmos o
      eventual acesso por menores de idade e por aqueles que não possuem plena capacidade civil
      sem a prévia autorização.
    </p>
    <p>
      Mediante a realização do cadastro o usuário declara e garante expressamente ser plenamente
      capaz, podendo exercer e usufruir livremente dos serviços e produtos.
    </p>
    <p>
      O usuário deverá fornecer um endereço de e-mail válido, através do qual o site realizará
      todas as comunicações necessárias.
    </p>
    <p>
      Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal, a qual
      assegura ao usuário o acesso individual à mesma. Desta forma, compete ao usuário
      exclusivamente a manutenção de referida senha de maneira confidencial e segura, evitando o
      acesso indevido às informações pessoais.
    </p>
    <p>
      Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do usuário,
      que deverá informar prontamente a plataforma em caso de uso indevido da respectiva senha.
    </p>
    <p>
      Não será permitido ceder, vender, alugar ou transferir, de qualquer forma, a conta, que é
      pessoal e intransferível.
    </p>
    <p>
      Caberá ao usuário assegurar que o seu equipamento seja compatível com as características
      técnicas que viabilize a utilização da plataforma e dos serviços ou produtos.
    </p>
    <p>
      O usuário poderá, a qualquer tempo, requerer o cancelamento de seu cadastro junto ao sistema
      {' '}
      <b>Benner Metrics</b>
      . O seu descadastramento será realizado o mais rapidamente possível, desde que
      não sejam verificados débitos em aberto.
    </p>

    <h3 className="section">5. Dos Serviços ou Produtos</h3>
    <p>
      A plataforma poderá dsponibilizar para o usuário um conjunto específico de funcionalidades
      e ferramentas para otimizar o uso dos serviços e produtos.
    </p>
    <p>
      Os serviços ou produtos oferecidos estarão descritos no site da provedora
      {' '}
      <a
        href="https://juristecplus.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://juristecplus.com.br
      </a>
      {' '}
      e nas documentações competentes, contendo informações sobre suas características, qualidades,
      quantidades, composição, preço, garantia, prazos de validade e origem, entre outros dados,
      bem como sobre os riscos que apresentam à saúde e segurança do usuário.
    </p>
    <p>
      Antes de finalizar a compra sobre determinado produto ou serviço, o usuário deverá se informar
      sobre as suas especificações e sobre a sua destinação.
    </p>

    <h3 className="section">6. Características do Benner Metrics</h3>
    <p>
      O
      {' '}
      <b>Benner Metrics</b>
      {' '}
      consiste em um software as a service (SAAS) de Business Intelligence desenvolvido para o setor
      jurídico. Ele permite integrar dados de diversas fontes, como relatórios de ERPs jurídicos,
      planilhas internas ou na nuvem e tabelas SQL e transformá-los em dashboards com indicadores
      estratégicos.
    </p>
    <p>
      O sistema recebe e processa apenas dados estruturados, os quais devem ser encaminhados pela
      CONTRATANTE no formato de tabelas CSV (comma-separated values) ou XLSX (Excel Microsoft Office
      Open XML Format Spreadsheet) ou integradas com relatórios de ERPs jurídicos utilizados pela
      CONTRATANTE ou ainda tabelas extraídas de bancos SQL ou planilhas armazenadas na nuvem.
    </p>
    <p>
      Os tipos de dados a serem inseridos pela CONTRATANTE disponíveis nas diversas fontes de dados,
      para inclusão no Benner Metrics deverão observar os seguintes formatos:
    </p>
    <ul>
      <li>
        <b>Número:</b>
        {' '}
        dado que representa um valor numérico. Poderá ser um número inteiro (integer) ou real (ponto
        flutuante float). Em geral, independente de como os dados são apresentados na interface do
        usuário com os demais sistemas (ERPs ou nuvem), os dados são formatados com “ponto” (“.”)
        como delimitador decimal. No caso de utilização do Google Spreadsheets ou Microsoft One
        Drive, qualquer formatação numérica tende a ser aceita (aqui estamos nos referindo a
        delimitador decimal, separador de milhar, formatação monetária, entre outras).
      </li>
      <li>
        <b>Texto:</b>
        {' '}
        variável categórica que representa uma informação qualitativa. É considerada uma sequência
        contínua de caracteres ASCII.
      </li>
      <li>
        <b>Data:</b>
        {' '}
        variável do tipo data que devem ser recebidas nos formatos AAAA-MM-DD ou DD/MM/AAAA.
      </li>
    </ul>
    <p>
      Os dados que não estejam no formato especificado poderão não ser aceitos pelo
      {' '}
      <b>Benner Metrics</b>
      {' '}
      , que não processará integralmente o arquivo que os contém e indicará ao usuário o motivo
      do não processamento.
    </p>
    <p>
      O
      {' '}
      <b>Benner Metrics</b>
      {' '}
      permite que o usuário, no momento da importação dos dados, ou em qualquer outro momento
      após a importação, possa alterar o tipo das colunas das tabelas disponíveis no sistema.
    </p>
    <p>
      O
      {' '}
      <b>Benner Metrics</b>
      {' '}
      é uma aplicação que opera em ambiente computacional virtualizado da JURISTEC+, e é
      utilizada através de navegadores da web (Safari versão 13.0.3, ou superior; Internet
      Explorer versão 11, ou superior; Chrome versão 78.0.3904.70, ou superior, e Firefox versão
      48.0. 51.0.1, ou superior).
    </p>

    <h3 className="section">6.1. Tipos de Usuários</h3>
    <p>
      Há três tipos de perfis de usuários do
      {' '}
      <b>Benner Metrics</b>
      {' '}
      :
      <ul>
        <li>
          <b>Convidado:</b>
          {' '}
          apto a visualizar, realizar download de relatórios e imprimir os dashboards que são
          compartilhados com ele.
        </li>
        <li>
          <b>Cientista:</b>
          {' '}
          apto a carregar (upload) as tabelas de dados, validar as informações, definir, criar
          e visualizar dashboards e  KPIs, criar e exportar os relatórios.
        </li>
        <li>
          <b>Usuário proprietário:</b>
          {' '}
          apto a gerenciar usuários e grupos no sistema, carregar (upload) as bases de dados,
          validar as informações, definir, criar e visualizar dashboards e KPIs, criar e exportar
          relatórios e configurar os relatórios de atualização automática.
        </li>
      </ul>
      <p>
        Ao contratar o
        {' '}
        <b>Benner Metrics</b>
        {' '}
        , é definido o usuário proprietário e as quantidades de usuários Cientistas e Convidados,
        como parte do plano contratado pela CONTRATANTE.
      </p>
      <p>
        A CONTRATANTE poderá contratar junto à JURISTEC+ quantidades adicionais de usuários
        proprietários, cientistas ou usuários convidados para o Benner Metrics, conforme política de
        preços da JURISTEC+.
      </p>
    </p>

    <h3 className="section">6.2. Instalação do Benner Metrics</h3>
    <p>
      Ao término do processo de instalação do Benner Metrics, a CONTRATANTE estará apta a utilizá-lo
      com o conjunto inicial de informações disponibilizadas.
    </p>
    <p>
      A instalação do
      {' '}
      <b>Benner Metrics</b>
      {' '}
      à CONTRATANTE consiste na adoção das seguintes etapas de trabalho:
    </p>
    <ul>
      <li>
        Criação da instância do
        {' '}
        <b>Benner Metrics</b>
        {' '}
        específica para a CONTRATANTE com os respectivos recursos computacionais alocados;
      </li>
      <li>
        Importação e integração das informações iniciais fornecidas pela CONTRATANTE, seja a partir
        de tabelas de dados internas, tabelas de dados extraídas de bases SQL, ou através de
        relatórios de dados gerados por sistemas de gestão de informação (ERPs jurídicos integrados
        ou arquivos em nuvem do usuário);
      </li>
      <li>
        Configuração dos KPIs e dashboards iniciais, como previsto no plano contratado pela
        CONTRATANTE, para a utilização imediata;
      </li>
      <li>
        Reunião de treinamento do sistema para as pessoas selecionadas pela CONTRATANTE.
      </li>
    </ul>
    <p>
      A plataforma
      {' '}
      <b>Benner Metrics</b>
      {' '}
      poderá disponibilizar aos usuários os seguintes treinamentos de utilização:
    </p>
    <ul>
      <li>
        <b>Treinamento Onboarding:</b>
        {' '}
        A ser usufruído durante os 3 primeiros meses de contrato para conhecimento da plataforma do
        {' '}
        <b>Benner Metrics</b>
        {' '}
        . O cliente receberá um link de agenda e selecionará os horários de acordo com a
        disponibilidade de agenda.
      </li>
      <li>
        <b>Treinamento Ongoing:</b>
        {' '}
        A ser usufruído após os 3 primeiros meses e até o final da vigência.
      </li>
    </ul>

    <h3 className="section">6.3. Configurações adicionais</h3>
    <p>
      A CONTRATANTE poderá contratar configurações adicionais disponibilizadas pela Benner (“ADD
      ONs”), especificados conforme condições  abaixo
    </p>
    <ul>
      <li>
        <b>Memória Virtual:</b>
        {' '}
        Disponibilização complementar de memória virtual. A memória será utilizada para a
        armazenagem das informações carregadas pela CONTRATANTE, pelos indicadores-chave (KPIs) e
        dashboards construídos, conforme política de preços da Benner.
      </li>
      <li>
        <b>Módulo integrado de inteligência artificial:</b>
        {' '}
        Disponibilização de um conjunto de agentes de inteligência artificial, integrados ao
        {' '}
        <b>Benner Metrics</b>
        {' '}
        , conforme política de preços constantes do Anexo III e seus respectivos aditamentos. Os
        agentes disponíveis são os seguintes:
        <ol>
          <li>
            <b>Chat com a base de dados:</b>
            {' '}
            Agente de inteligência artificial que permite que o usuário converse com a base de dados
            com o intuito de extrair informações consolidadas a partir do uso de um prompt feito em
            linguagem natural. Todo o histórico de conversas com a base de dados fica armazenado
            para consultas posteriores.
          </li>
          <li>
            <b>Criação de insights inteligentes:</b>
            {' '}
            permite que o usuário crie insights no formato de texto dentro de um dashboard a partir
            de uma base de dados. Os insights inteligentes são dinâmicos e suas informações são
            atualizadas conforme a base de dados é alterada.
          </li>
          <li>
            <b>Quaisquer outros agentes que venham a ser criados:</b>
            {' '}
            se porventura forem introduzidos novos agentes de inteligência artificial no
            {' '}
            <b>Benner Metrics</b>
            {' '}
            , esses agentes poderão estar disponíveis para a CONTRATANTE caso o módulo de
            inteligência artificial esteja incluído no plano contratado.
          </li>
        </ol>
      </li>
    </ul>
    <p>São observadas as seguintes condições:</p>
    <ul>
      <li>
        <b>Natureza da Resposta:</b>
        {' '}
        As respostas fornecidas são geradas automaticamente tendo por base um conjunto de dados
        rodados em rede neural, podendo ser imprecisas, incompletas, desatualizadas e, em casos
        raros, podem ser interpretadas como ofensivas ou inadequadas.
      </li>
      <li>
        <b>Sem Garantias:</b>
        {' '}
        Este serviço contém tecnologia pioneira e é fornecido no estado em que se encontra, não
        sendo garantida sua precisão, relevância ou adequação para qualquer propósito específico.
      </li>
      <li>
        <b>Responsabilidade do Usuário:</b>
        {' '}
        Ao utilizar o módulo de inteligência artificial, é de responsabilidade do usuário usá-lo
        com discernimento, interpretar as respostas com cuidado e consultar fontes adicionais ou
        profissionais quando necessário.
      </li>
    </ul>
    <p>
      As tecnologias de inteligência artificial generativa poderão sofrer alterações ou
      substituições conforme a necessidade da empresa, seja em razão de indisponibilidade, mudanças
      de projeto, ajustes comerciais, decisões técnicas ou estratégicas da CONTRATADA.
    </p>
    <p>
      A CONTRATANTE poderá contratar serviços adicionais disponibilizados pela Benner,
      especificados conforme abaixo:
    </p>
    <ul>
      <li>
        <b>Dashboards Personalizados:</b>
        {' '}
        Refere-se ao serviço de elaboração de dashboards sob demanda, ou seja, personalizados de
        acordo com os interesses específicos da CONTRATANTE, conforme política de preços da
        Benner. A execução deste serviço está condicionada à existência de uma base de dados
        disponível da CONTRATANTE. Não está incluído neste serviço nenhum trabalho adicional de
        construção, preparação ou saneamento de uma base de dados. Após a contratação deste serviço,
        a equipe Benner fará a avaliação da demanda e, em caso de não possibilidade de
        cumprimento, o serviço não será realizado e, consequentemente, nada será cobrado.
      </li>
      <li>
        <b>Consultoria Exclusiva:</b>
        {' '}
        Serviços complementares de consultoria especializada em jurimetria, conforme política de
        preços da Benner. A execução deste serviço deverá ser acompanhada de reunião prévia entre
        a CONTRATANTE e a equipe especializada da Benner para avaliação da viabilidade técnica e
        disponibilidade de dados prévios para sua execução.
      </li>
    </ul>

    <h3 className="section">6.4. Funcionalidades</h3>
    <p>
      O
      {' '}
      <b>Benner Metrics</b>
      {' '}
      simplifica a organização e análise das informações jurídicas através da geração de KPIs,
      validação de base de dados de informações e geração de dashboards para gestão de carteiras
      jurídicas.
    </p>
    <p>
      O
      {' '}
      <b>Benner Metrics</b>
      {' '}
      permite, dentre outras finalidades:
    </p>
    <ul>
      <li>
        atualização automática dos KPIs, conforme as mudanças da base e utilização dos procedimentos
        salvos. Essa funcionalidade permite que o trabalho de execução de um dashboard seja
        realizado uma única vez para depois, ser atualizado constantemente, conforme a fonte das
        informações sejam alteradas (tabelas do ERP, tabelas da nuvem, alterações dos arquivos do
        dispositivo do usuário, entre outras);
      </li>
      <li>
        disponibilizar KPIs jurídicos prontos e agrupados em dashboards, como por exemplo:
        “Trabalhista”, “Cível”, “Acordos”, “Financeiro”, Estratégico”, entre outros;
      </li>
      <li>
        criar livremente KPIs em diversas combinações;
      </li>
      <li>
        gerar gráficos que possuem filtros na própria interface do dashboard ou KPI;
      </li>
      <li>
        realizar funções matemáticas que permitem a implantação de jurimetria financeira.
      </li>
      <li>
        possibilidade de realização de download dos arquivos e bases do sistema, assim como dos
        relatórios filtrados responsáveis pelos diversos KPIs criados. Todos os KPIs podem ser
        exportados no formato de figura (extensão PNG) para que sejam utilizados em apresentações
        externas.
      </li>
      <li>
        Criação de relatórios customizados a partir das bases de dados importadas no sistema.
      </li>
      <li>
        O sistema possui um tracking de todos os arquivos, dashboards e KPIs de forma que é
        possível verificar os responsáveis pela criação, as últimas atualizações e o passo a passo
        utilizado para a criação dos KPIs.
      </li>
      <li>
        Possibilidade de criação de histórico de base de dados, permitindo a comparação de mudanças
        na base ao longo do tempo nos diversos períodos em que os históricos foram armazenados.
      </li>
      <li>
        Possibilidade de compartilhamento de dashboards externamente, permitindo que terceiros
        interessados possam visualizar dashboards executivos de forma simples e intuitiva.
      </li>
      <li>
        O sistema possui um sistema de suporte interno que permite que o usuário crie tickets com
        dúvidas que serão prontamente respondidas pelo time técnico da Benner.
      </li>
    </ul>

    <h3 className="section">6.5. Interface com os usuários</h3>
    <p>
      O
      {' '}
      <b>Benner Metrics</b>
      {' '}
      possui as seguintes interfaces para os usuários:
    </p>
    <ul>
      <li>
        <b>Interface de Dashboards:</b>
        {' '}
        Apresenta todos os dashboards próprios de um usuário ou os
        dashboards compartilhados por outros usuários. Nesta interface, os usuários podem criar
        novos dashboards, compartilhar seus próprios dashboards, clonar dashboards, apagar
        dashboards, acessar e filtrar informações, entre outras funcionalidades.
      </li>
      <li>
        <b>Interface de Arquivos:</b>
        {' '}
        Repositório de arquivos do sistema. Aqui são inseridas as diversas fontes de dados a
        partir das quais o usuário pode criar seus dashboards e KPIs. Cada arquivo é identificado
        conforme a sua fonte de origem. Os arquivos que o usuário insere de seu próprio dispositivo
        somente são atualizados quando o usuário atualizar as fonte de dados correspondentes. As
        demais fontes de dados integradas (ERPs, Google Sheets, One Drive, tabelas SQL, entre
        outras) são atualizadas diariamente de forma automática ou por necessidade do próprio
        usuário. Também é permitida a criação e gerenciamento de relatórios extraídos das bases de
        dados dos usuários.
      </li>
      <li>
        <b>Interface do dashboard:</b>
        {' '}
        Interface que apresenta o conjunto dos KPIs que constituem cada um dos dashboards do usuário
        ou de um dashboard compartilhado com este usuário.
      </li>
      <li>
        <b>Interface de Criação de KPI:</b>
        {' '}
        Interface que permite a criação dos KPIs a partir da seleção de variáveis de um arquivo,
        incorporando filtros e agrupamentos e estilos. Permite a seleção do tipo de gráfico e sua
        pré-visualização.
      </li>
      <li>
        <b>Interface de Gerenciamento da instância:</b>
        {' '}
        Interface onde os usuários proprietários e cientistas podem gerenciar os usuários atuais do
        sistema e/ou criar novos usuários. Nesta interface são listados todos os usuários, é
        possível fazer o bloqueio ou remoção de um usuário existente ou criar novos usuários para a
        utilização da ferramenta. Os usuários proprietários podem criar e gerenciar grupos inteiros
        de usuários, como por exemplo, replicando departamentos existentes em sua própria
        instituição.
      </li>
    </ul>

    <h3 className="section">6.6. Acordo de Nível de Serviço</h3>
    <p>
      Estão previstos os seguintes níveis de serviço para a utilização do
      {' '}
      <b>Benner Metrics</b>
      {' '}
      :
    </p>
    <ul>
      <li>
        <b>Intalação do Benner Metrics:</b>
        {' '}
        O tempo máximo para instalação do
        {' '}
        <b>Benner Metrics</b>
        {' '}
        será de 15 (quinze) dias úteis a contar do recebimento da solicitação pela equipe da
        JURISTEC+. O tempo de 15 (quinze) dias está condicionado à disponibilização, por parte do
        cliente, de todo e qualquer arquivo e/ou documentação necessária para o onboarding inicial
        do sistema. Importante ressaltar que neste período de 15 (quinze) dias, não estão incluídos
        serviços adicionais de integração com novos sistemas (J+ integra) e que podem depender de
        situações externas ao controle da JURISTEC+ ou que dependam de terceiros.
      </li>
      <li>
        <b>Instalação de Dashboards Personalizados:</b>
        {' '}
        Tempo de entrega de até 2 (duas) semanas, limitado a 20 KPIs, podendo o prazo ser estendido
        a depender de atraso por conta da CONTRATANTE. O prazo para a entrega de dashboards
        personalizados está condicionado à disponibilidade, por parte da CONTRATANTE, dos arquivos
        e/ou tabelas completas. Enquanto os arquivos ou tabelas estiverem indisponíveis ou
        incompletos esta tarefa não será executada.
      </li>
      <li>
        <b>Elaboração de Relatórios Integrados:</b>
        {' '}
        Tempo de entrega entre 2 (duas) até 4 (quatro) semanas. Entrega condicionada à viabilidade
        técnica a ser apreciada pela equipe da JURISTEC+. Não sendo possível a integração, não
        caberá nenhuma contrapartida ou indenização a quaisquer das partes.
      </li>
      <li>
        <b>Solicitação de Acesso Individual:</b>
        {' '}
        Para garantir a melhor extração de dados e correção de eventuais erros a CONTRATANTE deverá
        fornecer um acesso do ERP utilizado para a CONTRATADA. Caso não seja possível a liberação do
        acesso, é de responsabilidade do CONTRATANTE viabilizar meios para execução do serviço.
      </li>
      <li>
        <b>Suporte de 1º Nível:</b>
        {' '}
        Trata-se de suporte inicial voltado a orientar o usuário sobre o correto uso do
        {' '}
        <b>Benner Metrics</b>
        {' '}
        , a ser realizado na própria ferramenta através do botão identificado com o símbolo (?) ou a
        partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da JURISTEC+ deverá
        ser de 1 (um) dia útil.
      </li>
      <li>
        <b>Suporte de 2º Nível:</b>
        {' '}
        Trata-se de suporte voltado à resolução de comportamento inesperado do
        {' '}
        <b>Benner Metrics</b>
        {' '}
        , a ser realizado na própria ferramenta através do botão identificado com o símbolo (?) ou a
        partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da JURISTEC+ deverá
        ser de 5 (cinco) dias úteis.
      </li>
      <li>
        <b>Suporte de 3º Nível:</b>
        {' '}
        Trata-se de suporte voltado a resolver questões relacionadas à indisponibilidade do
        {' '}
        <b>Benner Metrics</b>
        {' '}
        , a ser realizado na própria ferramenta através do botão identificado com o símbolo (?) ou a
        partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da JURISTEC+ deverá
        ser de 1 (um) dia útil.
      </li>
    </ul>

    <h3 className="section">7. Das Limitações de Responsabilidade</h3>
    <p>
      Exceto pelas garantias especificamente previstas no presente Contrato, a Benner não concede
      garantias adicionais quanto ao uso dos softwares ora licenciados. A Benner não realizará e
      nem concede qualquer garantia de adequação, customização e/ou parametrização dos softwares ora
      contratados com qualquer sistema da CONTRATANTE.
    </p>
    <p>
      A Benner também não garante o uso ininterrupto dos softwares, considerando a dependência de
      serviços de telecomunicações prestados por terceiros e tendo em vista a impossibilidade de
      funcionamento integral e ininterrupto de qualquer sistema de telecomunicação ou de informática
      , durante 365 (trezentos e sessenta e cinco) dias por ano, 24 (vinte e quatro) horas por dia e
      nem que os softwares estarão isentos de erros.
    </p>
    <p>
      Caso a interrupção dos serviços tenha ocorrido em razão de falhas nos sistemas e ferramentas
      da CONTRATADA e, caso o restabelecimento do sistema não ocorra no prazo máximo de 48 (quarenta
      e oito) horas, a CONTRATANTE fará jus ao abatimento proporcional na fatura do mês,
      correspondente ao período de indisponibilidade do sistema.
    </p>
    <p>
      Os softwares contratados poderão sofrer interrupções de até 48 (quarenta e oito) horas por mês
      para manutenções e atualizações, desde que previamente informado à CONTRATANTE mediante
      notificação por e-mail ou aviso na própria plataforma. As manutenções e atualizações, quando
      necessárias, deverão ser realizadas preferencialmente fora do horário comercial e em finais de
      semana, não integrando as hipóteses de abatimento na fatura constantes da cláusula acima.
    </p>
    <p>
      A Benner não se responsabilizará pela preparação ou adequação das bases de dados da própria
      CONTRATANTE a serem utilizadas nos softwares.
    </p>
    <p>
      A CONTRATANTE declara ter ciência de que NENHUM DOS SOFTWARES E/OU SERVIÇOS ORA CONTRATADOS
      SUBSTITUEM A NECESSIDADE DE ACOMPANHAMENTO JURÍDICO ÀS ATIVIDADES DA CONTRATANTE. Os softwares
      contratados são automatizados e têm a finalidade de apenas facilitar a análise de dados e
      informações disponibilizados pela própria CONTRATANTE e/ou obtidos de fontes públicas. A
      Benner não se responsabiliza por erro de dados e/ou informações vindos da própria
      CONTRATANTE ou obtidos de fontes públicas, nem por quaisquer falhas na captura de tais dados e
      informações. Nenhuma informação ou dado disponibilizados nos softwares da Benner têm a
      função de substituir informações oficiais vindas de fontes públicas, incluindo, mas não se
      limitando, a informações vindas de tribunais de justiça, diários oficiais e demais entidades
      da administração pública direta ou indireta, não servindo as plataformas da Benner como
      instrumentos para controle de prazos processuais e recebimento de citação.
    </p>

    <h3 className="section">8. Da Confidencialidade</h3>
    <p>
      Informação Confidencial. Considera-se como “Informação Confidencial” quaisquer informações e
      dados revelados por uma parte (“Parte Divulgadora”), incluindo seus administradores,
      consultores, auditores, contadores, advogados, contratados, representantes ou empregados,
      podendo ser tangíveis ou intangíveis, transmitidos de qualquer forma, modificados ou não pela
      parte contrária (“Parte Receptora”), incluindo, mas não limitando-se a informações
      disponibilizadas pela Parte Divulgadora à Parte Receptora para inserção nas plataformas dos
      softwares contratados e demais dados, materiais e documentos que venham ser disponibilizados
      pela Parte Divulgadora à Parte Receptora em razão do presente Contrato.
    </p>
    <p>
      Não são consideradas Informações Confidenciais as informações que:
    </p>
    <ol type="I">
      <li>
        forem de conhecimento público ou assim se tornarem de forma outra que não pela divulgação
        pela Parte Receptora;
      </li>
      <li>
        já forem de conhecimento da Parte Receptora quando de sua divulgação pela Parte Divulgadora;
      </li>
      <li>
        forem divulgadas à Parte Receptora por outra fonte que não a Parte Divulgadora, desde que
        tal divulgação não tenha sido feita, no melhor conhecimento da Parte Receptora, em violação
        à obrigação de confidencialidade.
      </li>
    </ol>
    <p>
      A Parte Receptora ficará sujeita às seguintes obrigações:
    </p>
    <ol type="I">
      <li>
        não utilizar as Informações Confidenciais em proveito próprio ou para finalidade outra que
        não àquelas relacionadas ao objeto deste Contrato;
      </li>
      <li>
        manter as Informações Confidenciais em sigilo, divulgando-as apenas a seus administradores,
        empregados, prepostos, sócios, advogados, auditores e demais prestadores de serviços que
        necessitem receber as Informações Confidenciais para fins de avaliação, negociação e
        realização do presente Contrato, durante toda a vigência do presente Contrato e pelo
        período adicional de 5 (cinco) anos do seu término; e
      </li>
      <li>
        zelar pela manutenção do sigilo das Informações Confidenciais, tomando medidas razoáveis
        para proteger sua integridade e evitar sua divulgação.
      </li>
    </ol>
    <p>
      A Parte Receptora poderá divulgar quaisquer Informações Confidenciais caso assim requerido
      pela legislação ou regulamentação a que estiver sujeita, ou por ordem ou decisão judicial,
      administrativa ou arbitral. Neste caso, as Informações Confidenciais divulgadas deverão ser
      as mínimas necessárias para cumprimento da respectiva norma, ordem ou decisão, devendo a
      outra Parte ser informada, quando tal ato não implicar em violação legal.
    </p>

    <h3 className="section">9. Das Obrigações de Integridade</h3>
    <p>
      As partes declaram que cumprem e cumprirão, por toda a vigência do Contrato, as regras
      estabelecidas pelas Leis nº 12.846/2013 (Lei Anticorrupção) e nº 9.613/1998 (Lei de Lavagem
      de Dinheiro), suas respectivas regulamentações e alterações, e demais legislações
      pertinentes, inclusive no que tange ao combate à corrupção e à vedação à prática de
      qualquer ato lesivo à administração pública, nacional ou estrangeira, bem como declaram,
      sem prejuízo das demais obrigações legais, que não fizeram, farão, instruíram ou instruirão
      a entrega, oferta ou promessa, em interesse ou benefício próprio ou de terceiros, direta ou
      indiretamente, de vantagens indevidas para agentes públicos ou a terceira pessoa a eles
      relacionados.
    </p>
    <p>
      As partes, neste ato, declaram ainda que cumprem e cumprirão, por toda a vigência deste
      Contrato, a legislação e regulamentação referente: (a) à saúde e segurança ocupacional do
      trabalhador e de terceiros; (b) ao meio ambiente; (c) à previdência social; (d)
      à livre concorrência; (e) à defesa do consumidor; (f) aos direitos humanos; bem como
      declaram que suas políticas e atividades não permitem ou incentivam a prática de
      prostituição, atos discriminatórios de qualquer natureza, mão de obra infantil e/ou em
      condição análoga à de escravo.
    </p>

    <h3 className="section">10. Dos Preços</h3>
    <p>
      Os valores aplicados pelos serviços e produtos são aqueles constantes do contrato firmado
      com a Benner.
    </p>
    <p>
      Na contratação de determinado serviço ou produto, a plataforma poderá solicitar as
      informações financeiras do usuário, como CPF, endereço de cobrança e dados de cartões. Ao
      inserir referidos dados o usuário concorda que sejam cobrados, de acordo com a forma de
      pagamento que venha a ser escolhida, os preços então vigentes e informados quando da
      contratação. Referidos dados financeiros poderão ser armazenados para facilitar acessos e
      contratações futuras.
    </p>
    <p>
      A contratação dos serviços será renovada automaticamente pela plataforma, independentemente
      de comunicação ao usuário, mediante cobrança periódica da mesma forma de pagamento indicada
      pelo usuário quando da contratação do serviço.
    </p>

    <h3 className="section">8. Do Cancelamento</h3>
    <p>
      O usuário poderá cancelar a contratação dos serviços de acordo com os termos que forem
      definidos no momento de sua contratação. Ainda, o usuário também poderá cancelar os serviços
      em até 7 (sete) dias após a contratação, de acordo com o
      {' '}
      <a
        href="https://www.jusbrasil.com.br/legislacao/91585/c%C3%B3digo-de-defesa-do-consumidor-lei-8078-90"
        target="_blank"
        rel="noopener noreferrer"
      >
        Código de Defesa do Consumidor
      </a>
      {' '}
      (Lei no.
      {' '}
      <a
        href="https://www.jusbrasil.com.br/legislacao/91585/c%C3%B3digo-de-defesa-do-consumidor-lei-8078-90"
        target="_blank"
        rel="noopener noreferrer"
      >
        8.078/90
      </a>
      ).
    </p>

    <h3 className="section">9. Jurisdição Para Resolução de Conflitos</h3>
    <p>
      Para a solução de controvérsias decorrentes do presente instrumento será aplicado
      integralmente o direito brasileiro.
    </p>
    <p>
      Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra
      a sede da
      {' '}
      <b>Benner</b>
      .
    </p>
  </>
);

export default UseTermsBenner;
